import { useCallback, useEffect, useState } from 'react';
import bundledVersion from '../version.json';

const POLL_INTERVAL_MS = 2 * 60 * 1000; // 2 minutes
const LS_KEY = 'herzens_dismissed_version';

export function useVersionCheck(): { updateAvailable: boolean; dismiss: () => void } {
  const [newVersion, setNewVersion] = useState<string | null>(null);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        if (
          data.version &&
          data.version !== bundledVersion.version &&
          localStorage.getItem(LS_KEY) !== data.version
        ) {
          setNewVersion(data.version);
        }
      } catch {
        // network error — ignore silently
      }
    };

    check(); // run immediately on mount
    const id = setInterval(check, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  const dismiss = useCallback(() => {
    if (newVersion) {
      localStorage.setItem(LS_KEY, newVersion);
    }
    setNewVersion(null);
  }, [newVersion]);

  return { updateAvailable: newVersion !== null, dismiss };
}
